import { FxInput, useBaseForm } from "../../components/fx";
import type { ReactElement } from 'react';
import { useUserFormStore } from "../../controllers/UserFormController";

const User = () => {

    const { renderForm, errors } = useBaseForm({ storeHook: useUserFormStore });
    return (
        <>
            {renderForm()}
        </>
    );
}

export default User;
